import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Sentry, initSentry, isSentryEnabled } from "./sentry";

initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {isSentryEnabled ? (
      <Sentry.ErrorBoundary
        fallback={
          <div className="App">
            <main className="app-main">
              <p>Something went wrong. Please refresh and try again.</p>
            </main>
          </div>
        }
      >
        <App />
      </Sentry.ErrorBoundary>
    ) : (
      <App />
    )}
  </React.StrictMode>,
);
